<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <sarala-table
                    :model="model"
                    ref="table"
                    :sort="{ prop: 'created_at', sortDesc: true }"
                    :cellPadding="true"
                    :createRoute="{ name: 'reseller.create' }"
                    :resourceName="$tc('resources.reseller.name', 1)"
                    :exportable="true"
                >
                    <template #top-right>
                        <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon tile v-bind="attrs" v-on="on">
                                    <v-icon color="blue-grey" v-on="on">
                                        mdi-dots-horizontal-circle
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item @click="openNotifyAll(true)">
                                    <v-list-item-title>
                                        {{
                                            $t(
                                                'actions.reseller.notifyCustomers.label',
                                            )
                                        }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="openNotifyAll(false)">
                                    <v-list-item-title>
                                        {{
                                            $t(
                                                'actions.reseller.notifyCustomers.label2',
                                            )
                                        }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template #trade_name="{ item }">
                        <span class="caption"
                            >{{ $t('partner.index.table.tenant-code') }}:
                        </span>
                        <span class="body-2">{{ item.tenant_code }}</span>
                        <br />

                        <template v-if="item.cnpj">
                            <span class="caption"
                                >{{ $t('partner.index.table.trade-name') }}:
                            </span>
                            <span class="body-2 font-weight-medium">
                                {{ item.trade_name }}
                            </span>
                            <br />
                            <span class="caption"
                                >{{ $t('partner.form.labels.contact-name') }}:
                            </span>
                            <span class="body-2">{{ item.contact_name }}</span
                            ><br />
                        </template>

                        <template v-else>
                            <span class="caption"
                                >{{ $t('partner.index.table.name') }}:
                            </span>
                            <span class="body-2 font-weight-medium">
                                {{ item.trade_name }}
                            </span>
                            <br />
                        </template>

                        <span class="caption"
                            >{{
                                $t('resources.reseller.attributes.manager_id')
                            }}:
                        </span>
                        <span class="body-2">{{
                            managers[item.manager_id] || '-'
                        }}</span>
                        <br />

                        <span class="caption"
                            >{{ $t('partner.form.labels.erp-schema') }}:
                        </span>
                        <span class="body-2">{{ item.erp_schema }}</span>
                    </template>
                    <template #customers="{item}">
                        <span class="body-2">{{ item.indicators.activeCustomers }}</span>
                    </template>
                    <template #mmr="{item}">
                        <span class="body-2">{{ $n(item.indicators.mmr, 'currency') }}</span>
                    </template>
                    <template #lastActivation="{item}">
                        <span class="body-2">{{ item.lastActivation }}
                            {{ $t('partner.index.table.days') }}</span>
                    </template>
                    <template #status="{ item }">
                        <span class="body-2">{{ item.formattedStatus }}</span>
                    </template>
                    <template #notify_customers="{ item }">
                        <span class="body-2">{{
                            item.notify_customers ? 'Sim' : 'Não'
                        }}</span>
                    </template>
                    <template #actionHandler>
                        <ResellerActions
                            ref="actionHandler"
                            @modelChanged="$refs.table.getItems()"
                        />
                    </template>
                </sarala-table>
                <NotifyCustomersAll
                    ref="notifyCustomersAll"
                    @modelChanged="$refs.table.getItems()"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Reseller from '@/models/Reseller'
import ResellerActions from '@/components/actions/reseller/ResellerActions'
import NotifyCustomersAll from '@/components/actions/reseller/NotifyCustomersAll'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        ResellerActions,
        NotifyCustomersAll,
        SaralaTable,
    },

    data: () => {
        return {
            managers: {},
        }
    },

    computed: {
        model() {
            return new Reseller()
        },
    },

    methods: {
        lastActivationExpired(days) {
            if (days > 90) {
                return 'red--text text--darken-2'
            }

            return ''
        },

        async loadManagers() {
            await this.$store.dispatch('user/initManagers')
            let managers = {}
            this.$store.getters['user/managers'].forEach(
                user => (managers[user.id] = user.name),
            )
            this.managers = managers
        },

        openNotifyAll(value) {
            const first =
                (this.$refs.table &&
                    this.$refs.table.items &&
                    this.$refs.table.items[0]) ||
                null
            if (!first) {
                this.$bus.$emit(
                    'notify',
                    'warning',
                    this.$t('common.noRecordsFound'),
                )
                return
            }
            this.$refs.notifyCustomersAll.open({ id: first.id, value })
        },
    },

    created() {
        this.loadManagers()
    },
}
</script>
